module.exports = __webpack_public_path__ + "static/Balanced-Muscle-Activation-aa777b4ee33ee2fdc32776e3b7adb17c.webp";